import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

import { InfoModal } from 'components/common/Modal'
import { getAllFiltersName } from './helpers'

const FiltersChangeModal = ({
  open,
  onClose,
  onConfirm,
  originFilters,
  tag,
  tagCategories,
}) => {
  const filterNames = getAllFiltersName(tagCategories, originFilters)
  return (
    <InfoModal open={open} onClose={onClose}>
      <Typography variant="subtitle2">
        <Box p={5}>是否更改篩選條件</Box>
      </Typography>

      <Box px={5}>
        是否要把篩選條件從
        {filterNames?.map((name) => `「${name}」`).join('')}
        改成篩選 「{tag?.name}」 ？
      </Box>

      <Box display="flex" justifyContent="flex-end" p={5}>
        <Box mr={2.5}>
          <Button variant="outlined" onClick={onClose} size="small">
            取消
          </Button>
        </Box>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => onConfirm(tag)}
        >
          確定
        </Button>
      </Box>
    </InfoModal>
  )
}

export default FiltersChangeModal
